/**
 * @fileoverview Reusable icon button with tooltip for consistent UI patterns
 * across the application.
 */

import { forwardRef, type ReactNode } from 'react';
import { IconButton, type IconButtonProps, Tooltip } from '@mui/material';

export interface TooltipIconButtonProps extends Omit<IconButtonProps, 'title'> {
  /**
   * Tooltip text to display
   */
  tooltip: string;
  /**
   * Icon to render inside the button
   */
  children: ReactNode;
  /**
   * Delay before showing tooltip (in ms)
   * @default 500
   */
  enterDelay?: number;
}

export const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
  function TooltipIconButton(props, ref) {
    const { tooltip, children, enterDelay = 500, ...iconButtonProps } = props;

    return (
      <Tooltip title={tooltip} enterDelay={enterDelay}>
        <span>
          <IconButton ref={ref} {...iconButtonProps}>
            {children}
          </IconButton>
        </span>
      </Tooltip>
    );
  },
);

